import React from "react";
import { Link } from "react-router-dom";
import Webcam from "react-webcam";
import DataSender, { DEEP_URL } from "../lib/DataSender";

export default class UserTrain extends React.Component {
  constructor(props) {
    super(props);
    this.webcams = [React.createRef(), React.createRef()];
    this.viewRef = React.createRef();
    this.refresh = null;
    this.state = {
      ...props.location.state,
      devices: [],
      deviceId: {},
      result: [],
    };
    this.ds = new DataSender();
  }

  async componentDidMount() {
    await fetch(`${DEEP_URL}/id`, {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Cache: "no-cache",
      },
      body: JSON.stringify({ id: this.state.dt_number }),
    });

    this.refresh = setInterval(() => {
      this.sendCapture();
    }, 300);
  }

  componentWillUnmount() {
    clearInterval(this.refresh);
  }

  sendCapture() {
    let fd = new FormData();
    let file = this.getBlobFromByte();

    if (!(file[0] && file[1])) return;

    fd.append("front", file[0], "front.jpg");
    fd.append("side", file[1], "side.jpg");

    fetch(`${DEEP_URL}/dupload/${this.state.dt_number}`, {
      method: "POST",
      mode: "cors",
      body: fd,
    })
      .then((x) => x.json())
      .then((x) => {
        if (x.length === 1) {
          window.location.pathname = "/MainTrain";
        } else {
          this.setState({ result: x });
        }
      });
  }

  selectDevices = (devices) => {
    let str = "";
    if (!localStorage.getItem("front_cam")) {
      str = "정면 카메라를 선택해주세요";
      devices.forEach((x, i) => {
        str += `\n${i}. ${x.label}`;
      });
      let i = prompt(str);
      localStorage.setItem("front_cam", parseInt(i));
    }
    if (!localStorage.getItem("side_cam")) {
      str = "측면 카메라를 선택해주세요";
      devices.forEach((x, i) => {
        str += `\n${i}. ${x.label}`;
      });
      let i = prompt(str);
      localStorage.setItem("side_cam", parseInt(i));
    }
    let front = localStorage.getItem("front_cam");
    let side = localStorage.getItem("side_cam");

    return [devices[front], devices[side]];
  };

  handleDevices = (mediaDevices) => {
    let devices = mediaDevices.filter(({ kind }) => kind === "videoinput");
    let result;
    while (true) {
      try {
        result = this.selectDevices(devices);
      } catch {
        continue;
      }
      if (result[0] && result[1]) {
        break;
      } else {
        localStorage.clear();
      }
    }
    this.setState({ devices: result });
  };

  getDivice = () => {
    if (!navigator.mediaDevices) {
      alert("https 로 접속해주세요.");
      return null;
    }
    navigator.mediaDevices.enumerateDevices().then(this.handleDevices);
  };

  getBlobFromByte() {
    var dataURIS = this.webcams.map((x) => {
      return x.current?.getScreenshot();
    });

    return dataURIS.map((dataURI) => {
      try {
        var byteString = atob(dataURI.split(",")[1]);
        var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      } catch {}
      return null;
    });
  }

  deleteUser() {
    this.ds.deleteTrain([this.state.dt_number]);
  }

  render() {
    this.getDivice();
    return (
      <>
        <div style={{ paddingTop: "10%" }}>
          <h1>팔굽혀펴기</h1>
          <div style={{ display: "flex" }}>
            <div style={{ flex: "7 1 0" }}>
              <div
                onClick={() => {
                  localStorage.clear();
                }}
              >
                {this.state.devices.map((device, key) => (
                  <div key={key} style={{ display: "inline-block" }}>
                    <h1>{key === 0 ? "정면" : "측면"}</h1>
                    <Webcam
                      videoConstraints={{ deviceId: device.deviceId }}
                      id={key}
                      ref={this.webcams[key]}
                      audio={false}
                      screenshotFormat="image/jpeg"
                      style={{ width: "640px" }}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div style={{ flex: "3 1 0" }}>
              <div
                style={{
                  padding: "100px",
                  fontSize: "30px",
                  textAlign: "left",
                }}
              >
                <h4>
                  횟수/오자세 : {this.state.result[3]}/{this.state.result[4]}
                </h4>
                <p>
                  시간 : {this.state.result[0]?.toFixed(2)}/
                  {this.state.result[1]}
                </p>
                <p>이름 : {this.state.name}</p>
                <p>군번 : {this.state.dt_number}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="qrresult-buttons">
          <Link
            to={{
              pathname: "/QRread",
              state: {
                to: "/UserTrain",
                text: "체력 측정",
                cancel: "/MainTrain",
              },
            }}
            className="qrresult-button"
          >
            <button className="button" onClick={this.deleteUser.bind(this)}>
              <p>측정자 변경</p>
            </button>
          </Link>
        </div>
      </>
    );
  }
}

/*
        <div className="result-user-data">
          <p>횟수/오자세 : {this.state.result[3]}/{this.state.result[4]}</p>
          <p>시간 : {this.state.result[0]?.toFixed(2)}/{this.state.result[1]}</p>
          <p>이름 : {this.state.name}</p>
          <p>군번 : {this.state.dt_number}</p>
        </div>
*/
